import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    path: [],
}

const guestFileBreadcrumbSlice = createSlice({
    initialState,
    name: "guestfileBreadcrumb",
    reducers: {
        set_guest_path: (state, action) => {
            state.path = action.payload
        },
        // Enter Folder Dir Breadcrum
        enter_to_guest_directory: (state, action) => {
            state.path = [...state.path, action.payload]
        },
    }
})

export default guestFileBreadcrumbSlice.reducer;

export const {
    enter_to_guest_directory,
    set_guest_path,
} = guestFileBreadcrumbSlice.actions;
